import { useState } from "react";
import { toast } from "sonner";

import { Button } from "@buildpy/ui/button";
import { settleRedirect } from "@/lib/redirect-error";
import { startQuote, startRoughQuote } from "@/api/actions/customer";

interface Props {
  customerId: string;
  /** 가견적 버튼인가. 기본은 상세견적이다. */
  rough?: boolean;
  /** 버튼 글자 — 비우면 「가견적」·「견적 작성」. */
  label?: string;
  variant?: "primary" | "outline";
}

/**
 * 「견적 작성」·「가견적」. `<form action>` 으로 두면 액션이 실패했을 때 Next 에러 화면이 뜬다 —
 * 실패를 그 자리에서 토스트로 알리려고 클라이언트 버튼으로 둔다.
 * 성공하면 액션이 편집 화면으로 redirect 한다(예외로 흐르므로 여기서 잡지 않는다).
 */
const StartQuoteButton = ({ customerId, rough = false, label, variant }: Props) => {
  const [pending, setPending] = useState(false);

  const run = async () => {
    setPending(true);
    try {
      // 실패만 `ok === false` 로 온다. 성공은 값이 아니라 redirect 예외로 끝난다.
      const result = rough
        ? await startRoughQuote(customerId)
        : await startQuote(customerId);
      if (result?.ok === false) toast.error(result.message);
    } catch (error) {
      // redirect 예외를 여기서 삼키면 「만들지 못했습니다」 가 뜬 채 편집기로 넘어간다.
      if (settleRedirect(error)) return;
      toast.error(`${rough ? "가견적" : "견적"}을 만들지 못했습니다`);
    } finally {
      setPending(false);
    }
  };

  return (
    <Button
      disabled={pending}
      size="sm"
      variant={variant ?? (rough ? "outline" : "primary")}
      onClick={() => void run()}>
      {label ?? (rough ? "가견적" : "견적 작성")}
    </Button>
  );
};

export default StartQuoteButton;
